import React from "react";
import { motion } from "framer-motion";

interface InterestCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  selected: boolean;
  onClick: () => void;
}

const InterestCard: React.FC<InterestCardProps> = ({ title, description, icon, selected, onClick }) => (
  <motion.div
    whileHover={{ scale: 1.02 }}
    whileTap={{ scale: 0.98 }}
    onClick={onClick}
    className={`cursor-pointer p-5 rounded-xl border-2 transition-all duration-300 ${
      selected ? "border-[#b3d130] bg-[#b3d130]/10 shadow-md" : "border-gray-200 hover:border-[#b3d130]/50 bg-white"
    }`}
  >
    <div className="flex items-start gap-4">
      <div className={`p-3 rounded-lg transition-all duration-300 ${selected ? "bg-[#b3d130] text-gray-900" : "bg-gray-100 text-gray-600"}`}>
        {icon}
      </div>
      <div className="flex-1">
        <div className="flex items-center justify-between">
          <h3 className={`font-semibold text-lg ${selected ? "text-[#b3d130]" : "text-gray-800"}`}>
            {title}
          </h3>
          {selected && <span className="text-[#b3d130]">✔</span>}
        </div>
        <p className="text-sm text-gray-500 mt-1">{description}</p>
      </div>
    </div>
  </motion.div>
);

export default InterestCard;
